import React from 'react';

import { TopMenuDropdown } from 'editor/src/store/app/types';
import getMediaElement from 'editor/src/store/design/selector/getMediaElement';
import isImageMaskAllowed from 'editor/src/store/editor/selector/isImageMaskAllowed';
import { useSelector } from 'editor/src/store/hooks';

import IconImageMask from 'editor/src/component/Icon/IconImageMask';
import ImageMaskControl from 'editor/src/component/ImageMaskControl';
import { MenuItemProps } from 'editor/src/component/Menu/type';
import ButtonWithDropdownNotWrapped from 'editor/src/component/TopMenuDesktop/buttons/ButtonWithDropdownNotWrapped';
import MenuDropDownButton from 'editor/src/component/TopMenuDesktop/buttons/MenuDropDownButton';

function ButtonImageMaskDropDown({ mode, context }: MenuItemProps) {
  const selectedElement = useSelector((state) =>
    context.structureIndexes[0] ? getMediaElement(state, context.structureIndexes[0]) : undefined,
  );
  const hasShapes = useSelector(isImageMaskAllowed);
  if (selectedElement?.type !== 'image') {
    return null;
  }

  return (
    <ButtonWithDropdownNotWrapped
      dropDownName={TopMenuDropdown.ImageMask}
      buttonExtraClass="cy-button-image-mask"
      dropdownExtraClass="px-0"
      dropDownContent={<ImageMaskControl selectedElement={selectedElement} />}
      buttonContent={
        <MenuDropDownButton
          Icon={IconImageMask}
          mode={mode}
          i18nKey={hasShapes ? 'editor-image-shape' : 'editor-image-soft-edge'}
        />
      }
    />
  );
}

export default React.memo(ButtonImageMaskDropDown);
